import axios from '@axios'

const PREFIX = 'sublimites'

export default {

  getPaginado(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`, filtros)
  },

  getURL(id) {
    return axios.get(`${PREFIX}/${id}/url`)
  },

  baixaEmLote(filtros, nomeArquivo) {
    return axios.post(`${PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`, filtros)
  },

  getDocWhatsapp(id) {
    return axios.get(`${PREFIX}/${id}/url-whatsapp`)
  },

  getHistorico(tipo, empresaId, filtros) {
    return axios.post(`${PREFIX}/historico?empresaId=${empresaId}&pagina=${filtros?.pagina ?? 1}&tamanhoPagina=${filtros?.tamanhoPagina ?? 50}`, filtros)
  },

  notificaSublimite(nomeEmpresa, emailEmpresa, emailCc, id) {
    return axios.post(`${PREFIX}/${id}/notifica?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}`)
  },

  notificaHistorico(nomeEmpresa, emailEmpresa, emailCc, mensagemAdicional, definirEmailPadrao, ids) {
    const idsArray = Array.isArray(ids) ? ids : [ids]
    return axios.post(`${PREFIX}/notifica-historico?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional || '')}&definirEmailPadrao=${definirEmailPadrao}`, idsArray)
  },

  baixarSelecionados(ids) {
    const idsArray = Array.isArray(ids) ? ids : [ids]
    return axios.post(`${PREFIX}/baixar-selecionadas`, idsArray)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },
}
